"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var inline_icon_1 = tslib_1.__importDefault(require("../../../../../../ui-components/inline-icon/inline-icon"));
var card_scss_1 = tslib_1.__importDefault(require("../../card.scss"));
var ArrowRightLongIcon_1 = tslib_1.__importDefault(require("../../../../../../../icons/compiled/components/ArrowRightLongIcon"));
var withStyles_1 = require("../../../../../../utils/withStyles");
var ProductCardContent = /** @class */ (function (_super) {
    tslib_1.__extends(ProductCardContent, _super);
    function ProductCardContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductCardContent.prototype.renderThumbnail = function () {
        var cardData = this.props.cardData;
        var thumbnailUrl = cardData.thumbnailUrl;
        if (!thumbnailUrl) {
            return null;
        }
        return (react_1.default.createElement("div", { className: card_scss_1.default.thumbnail },
            react_1.default.createElement("div", { className: card_scss_1.default.image, style: { backgroundImage: "url(" + thumbnailUrl + ")" } })));
    };
    ProductCardContent.prototype.renderText = function () {
        var cardData = this.props.cardData;
        var text = cardData.text;
        return (react_1.default.createElement("div", { className: card_scss_1.default.text },
            react_1.default.createElement("div", { className: card_scss_1.default['text-content'], "data-hook": "action-card-title" }, text)));
    };
    ProductCardContent.prototype.renderCta = function () {
        var cardData = this.props.cardData;
        var buttonLabel = cardData.buttonLabel;
        return (react_1.default.createElement("div", { className: card_scss_1.default.cta },
            react_1.default.createElement("div", { className: card_scss_1.default['cta-label'], "data-hook": "action-card-action-text" }, buttonLabel),
            react_1.default.createElement("span", { className: card_scss_1.default['cta-icon-container'] },
                react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(ArrowRightLongIcon_1.default, null), className: card_scss_1.default['icon-arrow'] }))));
    };
    ProductCardContent.prototype.render = function () {
        var _a = this.props, className = _a.className, isAriaHidden = _a.isAriaHidden;
        return (react_1.default.createElement("div", { className: className, "aria-hidden": isAriaHidden },
            this.renderThumbnail(),
            react_1.default.createElement("div", { className: card_scss_1.default.container },
                this.renderText(),
                this.renderCta())));
    };
    ProductCardContent.propTypes = {
        cardData: prop_types_1.default.object,
        className: prop_types_1.default.string,
        isAriaHidden: prop_types_1.default.bool,
    };
    ProductCardContent = tslib_1.__decorate([
        withStyles_1.withStyles(card_scss_1.default)
    ], ProductCardContent);
    return ProductCardContent;
}(react_1.default.Component));
exports.default = ProductCardContent;
//# sourceMappingURL=card-content.js.map